export default "__VITE_ASSET__BVu9OycT__"